module.exports = __webpack_public_path__ + "static/media/SequenceGame.08f09655.png";